import { useEffect } from 'react'

import { useSnackbar } from '@/hooks/useSnackbar'
import { setQueryErrorNotifier } from '@/query/queryClient'

/**
 * Bridges the shared QueryClient's error handlers to the app's snackbar.
 *
 * Renders nothing. Must sit inside `SnackbarProvider`; the QueryClient lives
 * outside React so it can't reach the snackbar context on its own.
 */
export const QueryErrorNotifier = (): null => {
  const { showError } = useSnackbar()

  useEffect(() => {
    setQueryErrorNotifier(showError)
    return () => setQueryErrorNotifier(null)
  }, [showError])

  return null
}
